import { App } from 'vue'
import {
  fixDateFormat,
  iraqTime,
  readableDiff,
  reportTime,
  scanStartTime,
  utcFormat
} from '@/utils/filters'

export const setupFilters = (app: App): void => {
  app.config.globalProperties.$filters = {
    fixDateFormat,
    iraqTime,
    readableDiff,
    reportTime,
    scanStartTime,
    utcFormat
  }
}
